import React from 'react';
import SignUp from './SignUp';
import {DieselRoute} from 'epic-diesel-common/src/hocs';

class SignUpView extends React.Component {
    render() {
        return <SignUp />;
    }
}

export default DieselRoute(SignUpView, {path: 'signup'});
